import { createSelector } from 'reselect';
import { selectorFunctions } from 'redux/utils/selectors';

const { getData, getLoaded, getLoading, getError } = selectorFunctions;

const getGlobalState = state => state.cardIssuingActivate;

const getActivateIssuingCardPage = createSelector([getGlobalState], state => state.page);
export const getActivateIssuingCardPageData = createSelector(
  [getActivateIssuingCardPage],
  getData
);
export const getActivateIssuingCardPageLoaded = createSelector(
  [getActivateIssuingCardPage],
  getLoaded
);
export const getActivateIssuingCardPageLoading = createSelector(
  [getActivateIssuingCardPage],
  getLoading
);
export const getActivateIssuingCardPageError = createSelector(
  [getActivateIssuingCardPage],
  getError
);

const getActivateCardState = createSelector(
  [getGlobalState],
  state => state.activateCard
);
export const getActivateIssuedCardData = createSelector([getActivateCardState], getData);
export const getActivateIssuedCardLoaded = createSelector(
  [getActivateCardState],
  getLoaded
);
export const getActivateIssuedCardLoading = createSelector(
  [getActivateCardState],
  getLoading
);
export const getActivateIssuedCardError = createSelector(
  [getActivateCardState],
  getError
);

const getResetPINPage = createSelector([getGlobalState], state => state.resetPage);
export const getResetPINPageData = createSelector([getResetPINPage], getData);
export const getResetPINPageLoaded = createSelector([getResetPINPage], getLoaded);

const getResetPINState = createSelector([getGlobalState], state => state.resetPIN);
export const getResetPINData = createSelector([getResetPINState], getData);
export const getResetPINLoading = createSelector([getResetPINState], getLoading);

const getCardIssuingState = createSelector([getGlobalState], state => state.cardIssuing);
export const getCardIssuingData = createSelector([getCardIssuingState], getData);

const getSetKbaPage = createSelector([getGlobalState], state => state.setKbaPage);
export const getSetKbaPageData = createSelector([getSetKbaPage], getData);
export const getSetKbaPageLoaded = createSelector([getSetKbaPage], getLoaded);

const getSetKbaState = createSelector([getGlobalState], state => state.setKba);
export const getSetKbaData = createSelector([getSetKbaState], getData);
export const getSetKbaLoading = createSelector([getSetKbaState], getLoading);

const getViewPINState = createSelector([getGlobalState], state => state.viewPIN);
export const getViewPINData = createSelector([getViewPINState], getData);
export const getViewPINLoading = createSelector([getViewPINState], getLoading);

const getResetRedirectedState = createSelector(
  [getGlobalState],
  state => state.resetRedirected
);
export const getResetRedirectedLoading = createSelector(
  [getResetRedirectedState],
  getLoading
);
